import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Link from '../../../components/Link';
import {
    formatLargeNumber,
    formatNumber,
    getDecimals,
} from '../../../service/market';
import css from '../../../styles/front/overviewtable';

class OverviewTableRow extends Component {
    static propTypes = {
        breakpoint: PropTypes.string,
        ranking: PropTypes.string.isRequired,
        ITEM_SECTOR: PropTypes.string,
        LONG_NAME: PropTypes.string,
        LAST: PropTypes.number,
        LASTNZ: PropTypes.number,
        LASTNZ_DIV: PropTypes.number,
        CHANGE: PropTypes.number,
        CHANGE_PCT: PropTypes.number,
        TURNOVER: PropTypes.number,
        TURNOVER_MAX: PropTypes.number,
        TURNOVER_TOTAL: PropTypes.number,
    };

    constructor(props) {
        super(props);

        this.state = ({ sign: css.neutral });

        this._setSign = (value) => {
            if (value && value >= 0) {
                this.setState({ sign: css.positive });
            } else if (value && value < 0) {
                this.setState({ sign: css.negative });
            } else {
                this.setState({ sign: css.neutral });
            }
        };
    }

    componentDidMount() {
        this._setSign(this.props.CHANGE_PCT);
    }

    componentWillReceiveProps(nextProps) {
        this._setSign(nextProps.CHANGE_PCT);
    }

    renderName() {
        const { LONG_NAME } = this.props;

        return (
            <div className={[css.ellipsis, css.bold, css.tableCell].join(' ')}>
                {LONG_NAME}
            </div>
        );
    }

    renderChangePct() {
        const { CHANGE_PCT } = this.props;
        const changePct = formatNumber(
            CHANGE_PCT,
            getDecimals(CHANGE_PCT),
            true
        );

        return (
            <div className={css.tableCell}>
                <span className={this.state.sign}>{changePct}</span>
            </div>
        );
    }

    renderLast() {
        const { LAST, LASTNZ, LASTNZ_DIV } = this.props;
        const last = formatNumber(
            (LAST || LASTNZ || LASTNZ_DIV),
            getDecimals(LAST || LASTNZ || LASTNZ_DIV)
        );

        return (
            <div className={css.tableCell}>
                {last}
            </div>
        );
    }

    renderTurnover() {
        const { TURNOVER } = this.props;
        const turnover = formatLargeNumber(TURNOVER, 2);

        return (
            <div className={css.tableCell}>
                {turnover}
            </div>
        );
    }

    renderTurnoverMax() {
        const { TURNOVER_MAX } = this.props;
        const turnoverMax = formatLargeNumber(TURNOVER_MAX, 2);

        return (
            <div className={css.tableCell}>
                {turnoverMax}
            </div>
        );
    }

    renderTurnoverTotal() {
        const { TURNOVER_TOTAL } = this.props;
        const turnoverTotal = formatLargeNumber(TURNOVER_TOTAL, 2);

        return (
            <div className={css.tableCell}>
                {turnoverTotal}
            </div>
        );
    }

    render() {
        const { ITEM_SECTOR, ranking } = this.props;
        const link = encodeURIComponent(ITEM_SECTOR).toUpperCase();

        switch (ranking) {
        case '-TURNOVER':
            return (
                <Link
                    to={`/instrument/${link}`}
                    className={[css.noLinkStyle, css.tableRow].join(' ')}
                >
                    {this.renderName()}
                    {this.renderTurnover()}
                    {this.renderChangePct()}
                </Link>
            );
        case '-TURNOVER_MAX':
            return (
                <Link
                    to={`/instrument/${link}`}
                    className={[css.noLinkStyle, css.tableRow].join(' ')}
                >
                    {this.renderName()}
                    {this.renderTurnoverMax()}
                    {this.renderChangePct()}
                </Link>
            );
        case '-TURNOVER_TOTAL':
            return (
                <Link
                    to={`/instrument/${link}`}
                    className={[css.noLinkStyle, css.tableRow].join(' ')}
                >
                    {this.renderName()}
                    {this.renderTurnoverTotal()}
                    {this.renderChangePct()}
                </Link>
            );
        case 'CHANGE_PCT':
        case '-CHANGE_PCT':
        default:
            return (
                <Link
                    to={`/instrument/${link}`}
                    className={[css.noLinkStyle, css.tableRow].join(' ')}
                >
                    {this.renderName()}
                    {this.renderLast()}
                    {this.renderChangePct()}
                </Link>
            );
        }
    }
}

export default OverviewTableRow;



/** WEBPACK FOOTER **
 ** /src/shared/components/front/overview/OverviewTableRow.js
 **/